<div class="container mt-5">
  <div class="row mb-5">
    <div class="col-12">
      <h1 class="text-center">Transfer of keepership request</h1>
    </div>
  </div>

  <form #rehomePetForm="ngForm" (ngSubmit)="send()">
    <div class="modal-body">
      <div class="row mt-2">
        <div class="col-12">
          <ngb-alert
            *ngIf="alert"
            [type]="alert.type"
            (closed)="closeAlert()"
            class="sticky-top"
            style="top: 10px"
            >{{ alert.message }}</ngb-alert
          >

          <p>
            In order to process your transfer request, we’ll need you to fill in
            as much information as possible below. For security reasons, we’ll
            need to verify your request with the previous keeper.<br />
            This process can take up to 28 working days.
          </p>

          <div class="row">
            <div class="col-sm-6">
              <div class="mb-3">
                <label class="form-label" for="petChipNumber"> Chip number </label>
                <input
                  #petChipNumber="ngModel"
                  class="form-control"
                  id="petChipNumber"
                  name="petChipNumber"
                  [(ngModel)]="pet.chipNumber"
                  type="text"
                  disabled
                />
              </div>
            </div>

            <div class="col-sm-6">
              <div class="mb-3">
                <label class="form-label" for="petVetCode"> Vet Code </label>
                <input
                  #petVetCode="ngModel"
                  class="form-control"
                  id="petVetCode"
                  name="petVetCode"
                  [(ngModel)]="pet.vetCode"
                  type="text"
                  disabled
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="mb-3">
                <label class="form-label" for="keeperName"> Existing keeper name </label>
                <input
                  #keeperName="ngModel"
                  class="form-control"
                  [class.is-invalid]="keeperName.touched && keeperName.invalid"
                  id="keeperName"
                  name="keeperName"
                  [(ngModel)]="pet.existingKeeper.name"
                  placeholder="Existing keeper name"
                  type="text"
                  required
                />
                <div
                  *ngIf="keeperName.errors && keeperName.errors.required"
                  class="invalid-feedback"
                >
                  {{ errorStrings.required }}
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="mb-3">
                <label class="form-label" for="keeperPhone"> Existing keeper phone number </label>
                <input
                  #keeperPhone="ngModel"
                  class="form-control"
                  [class.is-invalid]="
                    keeperPhone.touched && keeperPhone.invalid
                  "
                  id="keeperPhone"
                  name="keeperPhone"
                  [(ngModel)]="pet.existingKeeper.phoneNumber"
                  [pattern]="validationPatterns.telephone"
                  placeholder="Existing keeper phone number"
                  type="text"
                />
                <div
                  *ngIf="keeperPhone.errors && keeperPhone.errors.required"
                  class="invalid-feedback"
                >
                  {{ errorStrings.required }}
                </div>
                <div
                  *ngIf="
                    keeperPhone.errors &&
                    keeperPhone.errors.pattern &&
                    !keeperPhone.errors.minlength
                  "
                  class="invalid-feedback"
                >
                  {{ errorStrings.telephoneInvalid }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="mb-3">
                <label class="form-label" for="species"> Species </label>
                <select
                  #petSpecies="ngModel"
                  class="form-control form-select"
                  [class.is-invalid]="petSpecies.touched && petSpecies.invalid"
                  id="petSpecies"
                  name="petSpecies"
                  [(ngModel)]="selectedSpecies"
                  (ngModelChange)="updateBreedsList()"
                  [disabled]="loadingSpecies"
                  required
                >
                  <option [ngValue]="null" disabled>
                    {{ loadingSpecies ? "Loading..." : "Please select..." }}
                  </option>
                  <option
                    *ngFor="let species of speciesList"
                    [ngValue]="species"
                  >
                    {{ species.description }}
                  </option>
                </select>
                <div
                  *ngIf="petSpecies.invalid && petSpecies.errors.required"
                  class="invalid-feedback"
                >
                  {{ errorStrings.required }}
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="mb-3">
                <label class="form-label" for="petBreed"> Breed </label>
                <input
                  #petBreed="ngModel"
                  #petBreedTypeahead="ngbTypeahead"
                  class="form-control"
                  [class.is-invalid]="petBreed.touched && petBreed.invalid"
                  id="petBreed"
                  name="petBreed"
                  [(ngModel)]="pet.breed"
                  [ngbTypeahead]="searchBreed"
                  [disabled]="!pet.species || loadingSpecies || loadingBreeds"
                  [placeholder]="
                    pet.species
                      ? 'Please enter the breed...'
                      : 'Select species first...'
                  "
                  [editable]="false"
                  placement="bottom-left"
                  (focus)="focus$.next($any($event).target.value)"
                  (click)="click$.next($any($event).target.value)"
                  type="text"
                />
                <div *ngIf="pet.species" class="text-muted mt-1">
                  <small
                    >Start typing to view suggestions and select from the
                    list.</small
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="mb-3">
                <label class="form-label" for="petName"> Pet name </label>
                <input
                  #petName="ngModel"
                  class="form-control"
                  id="petName"
                  name="petName"
                  [(ngModel)]="pet.name"
                  placeholder="Your pet's name"
                  type="text"
                />
              </div>
            </div>

            <div class="col-sm-6">
              <div class="mb-3">
                <label class="form-label" for="petSex"> Sex </label>
                <select
                  #petSex="ngModel"
                  class="form-control form-select"
                  [class.is-invalid]="petSex.touched && petSex.invalid"
                  id="petSex"
                  name="petSex"
                  [(ngModel)]="pet.gender"
                  required
                >
                  <option [ngValue]="null" disabled>Please select...</option>
                  <option [ngValue]="petGender.Male">Male</option>
                  <option [ngValue]="petGender.Female">Female</option>
                </select>
                <div
                  *ngIf="petSex.invalid && petSex.errors.required"
                  class="invalid-feedback"
                >
                  {{ errorStrings.required }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="mb-3">
                <label class="form-label" for="extraInfo"> Further information </label>
                <small class="form-text text-muted mb-3">
                  To speed up processing your request, please be sure to include
                  whether this pet has been purchased, inherited, rescued or
                  otherwise. As much detail as possible will expedite the
                  request.
                </small>
                <textarea
                  #extraInfo="ngModel"
                  class="form-control"
                  [class.is-invalid]="extraInfo.touched && extraInfo.invalid"
                  id="extraInfo"
                  name="extraInfo"
                  [(ngModel)]="pet.extraInfo"
                  rows="4"
                  required
                >
                </textarea>
                <div
                  *ngIf="extraInfo.invalid && extraInfo.errors.required"
                  class="invalid-feedback"
                >
                  {{ errorStrings.required }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-success text-white"
        [disabled]="!rehomePetForm.valid || submitButtonLoading"
        ngbAutofocus
        type="submit"
      >
        <fa-icon
          *ngIf="submitButtonLoading"
          [icon]="['fas', 'spinner']"
          [animation]="'spin'"
          class="me-3"
        ></fa-icon>
        {{ submitButtonLoading ? "Saving" : "Submit request" }}
      </button>
    </div>
  </form>
</div>
